// eslint-disable-next-line no-restricted-imports
import { useMultiStyleConfig as _useMultiStyleConfig, useStyleConfig as _useStyleConfig } from '@chakra-ui/react';
export function useStyleConfig(themeKey, props) {
  return _useStyleConfig(themeKey, props);
}
export function useMultiStyleConfig(themeKey, props) {
  return _useMultiStyleConfig(themeKey, props);
}
//# sourceMappingURL=use-style-config.js.map